<template>
  <div v-if="quickActions.length >= 4" class="quick-actions-card">
    <div class="quick-actions-header">
      <v-icon class="quick-icon" color="primary" size="28">mdi-lightning-bolt</v-icon>
      <h2>{{ $t('home.quickActions.title') }}</h2>
    </div>
    <p class="quick-sub">{{ $t('home.quickActions.subtitle') }}</p>
    <div class="quick-grid">
      <router-link
        v-for="(action, i) in quickActions"
        :key="i"
        :to="action.link"
        class="quick-item"
      >
        <div class="quick-icon-wrap">
          <v-icon class="q-icon" color="primary" size="32">{{ action.icon }}</v-icon>
        </div>
        <span class="quick-title">{{ action.title }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "quickActionsComponent",
  computed: {
    quickActions() {
      const screens = JSON.parse(sessionStorage.getItem("allowedScreens")) || [];
      const allowedKeys = [...screens];

      const allItems = [
        { title: this.$t("label.option.home"), icon: "mdi-home-outline", link: "/home", screen: "home" },
        { title: this.$t("label.option.marketplace"), icon: "mdi-store-outline", link: "/marketplace", screen: "marketplace" },
        { title: this.$t("label.option.board"), icon: "mdi-domain", link: "/board", screen: "board" },
        { title: this.$t("label.option.products"), icon: "mdi-cart-outline", link: "/product", screen: "product" },
        { title: this.$t("label.option.companies"), icon: "mdi-factory", link: "/companies", screen: "companies" },
        { title: this.$t("label.option.users"), icon: "mdi-account-cog-outline", link: "/users_admin", screen: "users_admin" },
        { title: this.$t("label.option.reserve"), icon: "mdi-folder-star-outline", link: "/buy_recognition", screen: "buy_recognition" },
        { title: this.$t("label.option.suppliers"), icon: "mdi-briefcase-check-outline", link: "/suppliers", screen: "suppliers" },
        { title: this.$t("label.option.reconciliation"), icon: "mdi-checkbox-marked-circle-outline", link: "/purchase_reconciliation", screen: "purchase_reconciliation" },
        { title: this.$t("label.option.assignment"), icon: "mdi-account-star-outline", link: "/shape_assignment", screen: "shape_assignment" },
        { title: this.$t("label.option.reports"), icon: "mdi-file-document-outline", link: "/reports", screen: "reports" },
        { title: this.$t("label.option.bonus"), icon: "mdi-gift-outline", link: "/bonus", screen: "bonus" },
        { title: this.$t("label.option.ads"), icon: "mdi-star-box-multiple-outline", link: "/ads", screen: "ads" },
        { title: this.$t("label.option.zenStar"), icon: "mdi-timer-star-outline", link: "/zen_star", screen: "zen_star" },
        { title: this.$t("label.option.mindSet"), icon: "mdi-head-cog-outline", link: "/mindset", screen: "mindset" },
        { title: this.$t("label.option.tipsCategories"), icon: "mdi-emoticon-happy-outline", link: "/tips-categories", screen: "tips-categories" },
        { title: this.$t("label.option.happinessTips"), icon: "mdi-emoticon-happy-outline", link: "/happiness-tips", screen: "happiness-tips" },
        { title: this.$t("label.option.surveys"), icon: "mdi-poll", link: "/surveys", screen: "surveys" },
        { title: this.$t("label.option.trivia"), icon: "mdi-trophy-outline", link: "/trivia", screen: "trivia" },
      ].filter((item) => allowedKeys.includes(item.screen));

      return allItems.slice(5, 9);
    },
  },
};
</script>

<style scoped>
.quick-actions-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 26px 28px;
  box-shadow: 0 10px 30px -14px rgba(59, 22, 96, 0.16);
  margin-top: 22px;
}

.quick-actions-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.quick-actions-header h2 {
  font-family: "Amsi Pro", "Poppins", sans-serif;
  font-size: 17px;
  font-weight: 600;
  color: #3b1660;
  margin: 0;
}

.quick-icon {
  color: #f97316;
}

.quick-sub {
  font-family: "Inter", "Nunito Sans", sans-serif;
  font-size: 12.5px;
  color: #6e6480;
  margin: 0 0 16px;
}

.quick-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.quick-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 18px 12px;
  border-radius: 16px;
  background: #f5f3ff;
  text-decoration: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.quick-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 14px -6px rgba(91, 33, 182, 0.25);
}

.quick-icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 10px -4px rgba(91, 33, 182, 0.18);
}

.q-icon {
  color: #5b21b6;
}

.quick-title {
  font-family: "Inter", "Nunito Sans", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #3b1660;
  text-align: center;
  line-height: 1.2;
}

@media (max-width: 900px) {
  .quick-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .quick-grid {
    grid-template-columns: 1fr;
  }
}
</style>
